import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'
import { H2 } from '@components/Typography'

export const Wrapper = styled.section`
  background-color: var(--white);
`

export const Title = styled(H2)`
  margin-top: 64px;
  margin-bottom: 32px;
  font-weight: 900;
  color: var(--primary-text);

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 104px;
  }
`

export const Item = styled.section`
  margin-bottom: 64px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 104px;
    margin-bottom: 104px;
    margin-left: auto;
    margin-right: auto;
    width: 311px;
  }
`

export const Icon = styled(Image)`
  width: 32px;
  height: 26px;
  margin-bottom: 20px;
`

export const Description = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #6b6b78;
  margin: 0 0 16px 0;
`

export const Author = styled.section`
  margin-bottom: 64px;
  font-weight: 900;
`
